import MagiclinkLogin from '@pages/MagiclinkLogin.vue';
import RequestSignUp from '@pages/RequestSignUp.vue';

const permissions = [
  {
    role: 'Member',
    access: false,
    redirect: 'Dashboard',
  },
  {
    role: 'Company',
    access: false,
    redirect: 'Dashboard',
  },
  {
    role: 'Superuser',
    access: false,
    redirect: 'Dashboard',
  },
];

export default [
  {
    path: '/',
    name: 'Home',
    component: MagiclinkLogin,
    meta: {
      permissions: permissions,
      flexContainer: true,
      noBodyBackground: true,
      hideNav: true,
    },
  },
  {
    path: '/request-signup',
    name: 'RequestSignUp',
    component: RequestSignUp,
    meta: {
      permissions: permissions,
      flexContainer: true,
      noBodyBackground: true,
      hideNav: true,
    },
  },
];
